import config from '../config.json';

export function apiEndpoint() {
	return config[process.env.REACT_APP_STAGE].api;
}
